import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const VenueAdminsRemoveDialog = makeConfirmActionDialog({
  mutationName: "venueAdminsRemove",
  paramName: "venueAdminIds",
  action: "Remove",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Remove",
    };
  },
});
